import type { SVGProps } from "react";

export function LogoutIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      role="img"
      aria-label="Log Out"
      {...props}
    >
      <path
        d="M4.57054 1.92857C5.07615 1.92857 5.48464 1.49766 5.48464 0.964286C5.48464 0.430915 5.07615 0 4.57054 0H2.74232C1.22833 0 0 1.29576 0 2.89286V10.6071C0 12.2042 1.22833 13.5 2.74232 13.5H4.57054C5.07615 13.5 5.48464 13.0691 5.48464 12.5357C5.48464 12.0023 5.07615 11.5714 4.57054 11.5714H2.74232C2.23671 11.5714 1.82821 11.1405 1.82821 10.6071V2.89286C1.82821 2.35949 2.23671 1.92857 2.74232 1.92857H4.57054ZM14.3572 7.43103C14.7143 7.05435 14.7143 6.44263 14.3572 6.06596L10.7008 2.20882C10.3437 1.83214 9.76381 1.83214 9.40673 2.20882C9.04966 2.58549 9.04966 3.19721 9.40673 3.57388L11.5035 5.78571H5.48464C4.97903 5.78571 4.57054 6.21663 4.57054 6.75C4.57054 7.28337 4.97903 7.71429 5.48464 7.71429H11.5035L9.40673 9.92612C9.04966 10.3028 9.04966 10.9145 9.40673 11.2912C9.76381 11.6679 10.3437 11.6679 10.7008 11.2912L14.3572 7.43404V7.43103Z"
        fill="currentColor"
      />
    </svg>
  );
}
